// Guardian AI Contact Service Protocol Definitions
// Public contact form submission
//
// Version: v1

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/contact/contact.proto (package guardianai.v1.contact, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/contact/contact.proto.
 */
export const file_guardianai_v1_contact_contact: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message guardianai.v1.contact.SubmitInquiryRequest
 */
export type SubmitInquiryRequest = Message<"guardianai.v1.contact.SubmitInquiryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * "General Inquiry", "Technical Support", "Business Inquiry", etc.
   *
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * Stable browser-generated UUID. Retrying the same submission must not create
   * another inquiry or send duplicate notifications.
   *
   * @generated from field: string client_submission_id = 5;
   */
  clientSubmissionId: string;

  /**
   * Optional structured service-funnel context. Generic contact forms may leave
   * these fields empty.
   *
   * @generated from field: string product_id = 6;
   */
  productId: string;

  /**
   * @generated from field: string funnel_id = 7;
   */
  funnelId: string;

  /**
   * @generated from field: string page_url = 8;
   */
  pageUrl: string;

  /**
   * @generated from field: string company = 9;
   */
  company: string;

  /**
   * @generated from field: string role = 10;
   */
  role: string;

  /**
   * @generated from field: string current_system = 11;
   */
  currentSystem: string;

  /**
   * @generated from field: string exact_problem = 12;
   */
  exactProblem: string;

  /**
   * @generated from field: string production_impact = 13;
   */
  productionImpact: string;

  /**
   * @generated from field: string desired_timeline = 14;
   */
  desiredTimeline: string;

  /**
   * @generated from field: string budget_range = 15;
   */
  budgetRange: string;

  /**
   * @generated from field: string nda_required = 16;
   */
  ndaRequired: string;

  /**
   * @generated from field: string utm_source = 17;
   */
  utmSource: string;

  /**
   * @generated from field: string utm_medium = 18;
   */
  utmMedium: string;

  /**
   * @generated from field: string utm_campaign = 19;
   */
  utmCampaign: string;

  /**
   * @generated from field: string utm_term = 20;
   */
  utmTerm: string;
};

/**
 * @generated from message guardianai.v1.contact.SubmitInquiryRequest
 */
export type SubmitInquiryRequestJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * "General Inquiry", "Technical Support", "Business Inquiry", etc.
   *
   * @generated from field: string category = 3;
   */
  category?: string;

  /**
   * @generated from field: string message = 4;
   */
  message?: string;

  /**
   * Stable browser-generated UUID. Retrying the same submission must not create
   * another inquiry or send duplicate notifications.
   *
   * @generated from field: string client_submission_id = 5;
   */
  clientSubmissionId?: string;

  /**
   * Optional structured service-funnel context. Generic contact forms may leave
   * these fields empty.
   *
   * @generated from field: string product_id = 6;
   */
  productId?: string;

  /**
   * @generated from field: string funnel_id = 7;
   */
  funnelId?: string;

  /**
   * @generated from field: string page_url = 8;
   */
  pageUrl?: string;

  /**
   * @generated from field: string company = 9;
   */
  company?: string;

  /**
   * @generated from field: string role = 10;
   */
  role?: string;

  /**
   * @generated from field: string current_system = 11;
   */
  currentSystem?: string;

  /**
   * @generated from field: string exact_problem = 12;
   */
  exactProblem?: string;

  /**
   * @generated from field: string production_impact = 13;
   */
  productionImpact?: string;

  /**
   * @generated from field: string desired_timeline = 14;
   */
  desiredTimeline?: string;

  /**
   * @generated from field: string budget_range = 15;
   */
  budgetRange?: string;

  /**
   * @generated from field: string nda_required = 16;
   */
  ndaRequired?: string;

  /**
   * @generated from field: string utm_source = 17;
   */
  utmSource?: string;

  /**
   * @generated from field: string utm_medium = 18;
   */
  utmMedium?: string;

  /**
   * @generated from field: string utm_campaign = 19;
   */
  utmCampaign?: string;

  /**
   * @generated from field: string utm_term = 20;
   */
  utmTerm?: string;
};

/**
 * Describes the message guardianai.v1.contact.SubmitInquiryRequest.
 * Use `create(SubmitInquiryRequestSchema)` to create a new message.
 */
export const SubmitInquiryRequestSchema: GenMessage<SubmitInquiryRequest, {jsonType: SubmitInquiryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 0);

/**
 * @generated from message guardianai.v1.contact.SubmitInquiryResponse
 */
export type SubmitInquiryResponse = Message<"guardianai.v1.contact.SubmitInquiryResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * Format: GAI-YYYYMMDD-XXXXX
   *
   * @generated from field: string case_id = 2;
   */
  caseId: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: bool persisted = 4;
   */
  persisted: boolean;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus staff_notification_status = 5;
   */
  staffNotificationStatus: InquiryEmailDeliveryStatus;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus visitor_confirmation_status = 6;
   */
  visitorConfirmationStatus: InquiryEmailDeliveryStatus;
};

/**
 * @generated from message guardianai.v1.contact.SubmitInquiryResponse
 */
export type SubmitInquiryResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * Format: GAI-YYYYMMDD-XXXXX
   *
   * @generated from field: string case_id = 2;
   */
  caseId?: string;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;

  /**
   * @generated from field: bool persisted = 4;
   */
  persisted?: boolean;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus staff_notification_status = 5;
   */
  staffNotificationStatus?: InquiryEmailDeliveryStatusJson;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus visitor_confirmation_status = 6;
   */
  visitorConfirmationStatus?: InquiryEmailDeliveryStatusJson;
};

/**
 * Describes the message guardianai.v1.contact.SubmitInquiryResponse.
 * Use `create(SubmitInquiryResponseSchema)` to create a new message.
 */
export const SubmitInquiryResponseSchema: GenMessage<SubmitInquiryResponse, {jsonType: SubmitInquiryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 1);

/**
 * @generated from message guardianai.v1.contact.ContactInquiry
 */
export type ContactInquiry = Message<"guardianai.v1.contact.ContactInquiry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId: string;

  /**
   * @generated from field: string client_submission_id = 3;
   */
  clientSubmissionId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string category = 6;
   */
  category: string;

  /**
   * @generated from field: string message = 7;
   */
  message: string;

  /**
   * @generated from field: string product_id = 8;
   */
  productId: string;

  /**
   * @generated from field: string funnel_id = 9;
   */
  funnelId: string;

  /**
   * @generated from field: string page_url = 10;
   */
  pageUrl: string;

  /**
   * @generated from field: string company = 11;
   */
  company: string;

  /**
   * @generated from field: string role = 12;
   */
  role: string;

  /**
   * @generated from field: string current_system = 13;
   */
  currentSystem: string;

  /**
   * @generated from field: string exact_problem = 14;
   */
  exactProblem: string;

  /**
   * @generated from field: string production_impact = 15;
   */
  productionImpact: string;

  /**
   * @generated from field: string desired_timeline = 16;
   */
  desiredTimeline: string;

  /**
   * @generated from field: string budget_range = 17;
   */
  budgetRange: string;

  /**
   * @generated from field: string nda_required = 18;
   */
  ndaRequired: string;

  /**
   * @generated from field: string utm_source = 19;
   */
  utmSource: string;

  /**
   * @generated from field: string utm_medium = 20;
   */
  utmMedium: string;

  /**
   * @generated from field: string utm_campaign = 21;
   */
  utmCampaign: string;

  /**
   * @generated from field: string utm_term = 22;
   */
  utmTerm: string;

  /**
   * @generated from field: guardianai.v1.contact.InquiryStatus status = 23;
   */
  status: InquiryStatus;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus staff_notification_status = 24;
   */
  staffNotificationStatus: InquiryEmailDeliveryStatus;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus visitor_confirmation_status = 25;
   */
  visitorConfirmationStatus: InquiryEmailDeliveryStatus;

  /**
   * @generated from field: string staff_notification_error = 26;
   */
  staffNotificationError: string;

  /**
   * @generated from field: string visitor_confirmation_error = 27;
   */
  visitorConfirmationError: string;

  /**
   * @generated from field: int32 notification_attempt_count = 28;
   */
  notificationAttemptCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_notification_attempt_at = 29;
   */
  lastNotificationAttemptAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 30;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 31;
   */
  updatedAt?: Timestamp;

  /**
   * Resend/provider message IDs make an accepted notification traceable even
   * when it never reaches the recipient's inbox.
   *
   * @generated from field: string staff_notification_provider_id = 32;
   */
  staffNotificationProviderId: string;

  /**
   * @generated from field: string visitor_confirmation_provider_id = 33;
   */
  visitorConfirmationProviderId: string;
};

/**
 * @generated from message guardianai.v1.contact.ContactInquiry
 */
export type ContactInquiryJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId?: string;

  /**
   * @generated from field: string client_submission_id = 3;
   */
  clientSubmissionId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name?: string;

  /**
   * @generated from field: string email = 5;
   */
  email?: string;

  /**
   * @generated from field: string category = 6;
   */
  category?: string;

  /**
   * @generated from field: string message = 7;
   */
  message?: string;

  /**
   * @generated from field: string product_id = 8;
   */
  productId?: string;

  /**
   * @generated from field: string funnel_id = 9;
   */
  funnelId?: string;

  /**
   * @generated from field: string page_url = 10;
   */
  pageUrl?: string;

  /**
   * @generated from field: string company = 11;
   */
  company?: string;

  /**
   * @generated from field: string role = 12;
   */
  role?: string;

  /**
   * @generated from field: string current_system = 13;
   */
  currentSystem?: string;

  /**
   * @generated from field: string exact_problem = 14;
   */
  exactProblem?: string;

  /**
   * @generated from field: string production_impact = 15;
   */
  productionImpact?: string;

  /**
   * @generated from field: string desired_timeline = 16;
   */
  desiredTimeline?: string;

  /**
   * @generated from field: string budget_range = 17;
   */
  budgetRange?: string;

  /**
   * @generated from field: string nda_required = 18;
   */
  ndaRequired?: string;

  /**
   * @generated from field: string utm_source = 19;
   */
  utmSource?: string;

  /**
   * @generated from field: string utm_medium = 20;
   */
  utmMedium?: string;

  /**
   * @generated from field: string utm_campaign = 21;
   */
  utmCampaign?: string;

  /**
   * @generated from field: string utm_term = 22;
   */
  utmTerm?: string;

  /**
   * @generated from field: guardianai.v1.contact.InquiryStatus status = 23;
   */
  status?: InquiryStatusJson;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus staff_notification_status = 24;
   */
  staffNotificationStatus?: InquiryEmailDeliveryStatusJson;

  /**
   * @generated from field: guardianai.v1.contact.InquiryEmailDeliveryStatus visitor_confirmation_status = 25;
   */
  visitorConfirmationStatus?: InquiryEmailDeliveryStatusJson;

  /**
   * @generated from field: string staff_notification_error = 26;
   */
  staffNotificationError?: string;

  /**
   * @generated from field: string visitor_confirmation_error = 27;
   */
  visitorConfirmationError?: string;

  /**
   * @generated from field: int32 notification_attempt_count = 28;
   */
  notificationAttemptCount?: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_notification_attempt_at = 29;
   */
  lastNotificationAttemptAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 30;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 31;
   */
  updatedAt?: TimestampJson;

  /**
   * Resend/provider message IDs make an accepted notification traceable even
   * when it never reaches the recipient's inbox.
   *
   * @generated from field: string staff_notification_provider_id = 32;
   */
  staffNotificationProviderId?: string;

  /**
   * @generated from field: string visitor_confirmation_provider_id = 33;
   */
  visitorConfirmationProviderId?: string;
};

/**
 * Describes the message guardianai.v1.contact.ContactInquiry.
 * Use `create(ContactInquirySchema)` to create a new message.
 */
export const ContactInquirySchema: GenMessage<ContactInquiry, {jsonType: ContactInquiryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 2);

/**
 * @generated from message guardianai.v1.contact.ListInquiriesRequest
 */
export type ListInquiriesRequest = Message<"guardianai.v1.contact.ListInquiriesRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: guardianai.v1.contact.InquiryStatus status = 4;
   */
  status: InquiryStatus;

  /**
   * @generated from field: string search = 5;
   */
  search: string;

  /**
   * @generated from field: bool notification_failures_only = 6;
   */
  notificationFailuresOnly: boolean;
};

/**
 * @generated from message guardianai.v1.contact.ListInquiriesRequest
 */
export type ListInquiriesRequestJson = {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken?: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId?: string;

  /**
   * @generated from field: guardianai.v1.contact.InquiryStatus status = 4;
   */
  status?: InquiryStatusJson;

  /**
   * @generated from field: string search = 5;
   */
  search?: string;

  /**
   * @generated from field: bool notification_failures_only = 6;
   */
  notificationFailuresOnly?: boolean;
};

/**
 * Describes the message guardianai.v1.contact.ListInquiriesRequest.
 * Use `create(ListInquiriesRequestSchema)` to create a new message.
 */
export const ListInquiriesRequestSchema: GenMessage<ListInquiriesRequest, {jsonType: ListInquiriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 3);

/**
 * @generated from message guardianai.v1.contact.ListInquiriesResponse
 */
export type ListInquiriesResponse = Message<"guardianai.v1.contact.ListInquiriesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.contact.ContactInquiry inquiries = 1;
   */
  inquiries: ContactInquiry[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * @generated from message guardianai.v1.contact.ListInquiriesResponse
 */
export type ListInquiriesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.contact.ContactInquiry inquiries = 1;
   */
  inquiries?: ContactInquiryJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount?: string;
};

/**
 * Describes the message guardianai.v1.contact.ListInquiriesResponse.
 * Use `create(ListInquiriesResponseSchema)` to create a new message.
 */
export const ListInquiriesResponseSchema: GenMessage<ListInquiriesResponse, {jsonType: ListInquiriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 4);

/**
 * @generated from message guardianai.v1.contact.GetInquiryRequest
 */
export type GetInquiryRequest = Message<"guardianai.v1.contact.GetInquiryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId: string;
};

/**
 * @generated from message guardianai.v1.contact.GetInquiryRequest
 */
export type GetInquiryRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message guardianai.v1.contact.GetInquiryRequest.
 * Use `create(GetInquiryRequestSchema)` to create a new message.
 */
export const GetInquiryRequestSchema: GenMessage<GetInquiryRequest, {jsonType: GetInquiryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 5);

/**
 * @generated from message guardianai.v1.contact.GetInquiryResponse
 */
export type GetInquiryResponse = Message<"guardianai.v1.contact.GetInquiryResponse"> & {
  /**
   * @generated from field: guardianai.v1.contact.ContactInquiry inquiry = 1;
   */
  inquiry?: ContactInquiry;
};

/**
 * @generated from message guardianai.v1.contact.GetInquiryResponse
 */
export type GetInquiryResponseJson = {
  /**
   * @generated from field: guardianai.v1.contact.ContactInquiry inquiry = 1;
   */
  inquiry?: ContactInquiryJson;
};

/**
 * Describes the message guardianai.v1.contact.GetInquiryResponse.
 * Use `create(GetInquiryResponseSchema)` to create a new message.
 */
export const GetInquiryResponseSchema: GenMessage<GetInquiryResponse, {jsonType: GetInquiryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 6);

/**
 * @generated from message guardianai.v1.contact.UpdateInquiryStatusRequest
 */
export type UpdateInquiryStatusRequest = Message<"guardianai.v1.contact.UpdateInquiryStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: guardianai.v1.contact.InquiryStatus status = 2;
   */
  status: InquiryStatus;
};

/**
 * @generated from message guardianai.v1.contact.UpdateInquiryStatusRequest
 */
export type UpdateInquiryStatusRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: guardianai.v1.contact.InquiryStatus status = 2;
   */
  status?: InquiryStatusJson;
};

/**
 * Describes the message guardianai.v1.contact.UpdateInquiryStatusRequest.
 * Use `create(UpdateInquiryStatusRequestSchema)` to create a new message.
 */
export const UpdateInquiryStatusRequestSchema: GenMessage<UpdateInquiryStatusRequest, {jsonType: UpdateInquiryStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 7);

/**
 * @generated from message guardianai.v1.contact.UpdateInquiryStatusResponse
 */
export type UpdateInquiryStatusResponse = Message<"guardianai.v1.contact.UpdateInquiryStatusResponse"> & {
  /**
   * @generated from field: guardianai.v1.contact.ContactInquiry inquiry = 1;
   */
  inquiry?: ContactInquiry;
};

/**
 * @generated from message guardianai.v1.contact.UpdateInquiryStatusResponse
 */
export type UpdateInquiryStatusResponseJson = {
  /**
   * @generated from field: guardianai.v1.contact.ContactInquiry inquiry = 1;
   */
  inquiry?: ContactInquiryJson;
};

/**
 * Describes the message guardianai.v1.contact.UpdateInquiryStatusResponse.
 * Use `create(UpdateInquiryStatusResponseSchema)` to create a new message.
 */
export const UpdateInquiryStatusResponseSchema: GenMessage<UpdateInquiryStatusResponse, {jsonType: UpdateInquiryStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 8);

/**
 * @generated from message guardianai.v1.contact.RetryInquiryNotificationsRequest
 */
export type RetryInquiryNotificationsRequest = Message<"guardianai.v1.contact.RetryInquiryNotificationsRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.contact.RetryInquiryNotificationsRequest
 */
export type RetryInquiryNotificationsRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.contact.RetryInquiryNotificationsRequest.
 * Use `create(RetryInquiryNotificationsRequestSchema)` to create a new message.
 */
export const RetryInquiryNotificationsRequestSchema: GenMessage<RetryInquiryNotificationsRequest, {jsonType: RetryInquiryNotificationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 9);

/**
 * @generated from message guardianai.v1.contact.RetryInquiryNotificationsResponse
 */
export type RetryInquiryNotificationsResponse = Message<"guardianai.v1.contact.RetryInquiryNotificationsResponse"> & {
  /**
   * @generated from field: guardianai.v1.contact.ContactInquiry inquiry = 1;
   */
  inquiry?: ContactInquiry;
};

/**
 * @generated from message guardianai.v1.contact.RetryInquiryNotificationsResponse
 */
export type RetryInquiryNotificationsResponseJson = {
  /**
   * @generated from field: guardianai.v1.contact.ContactInquiry inquiry = 1;
   */
  inquiry?: ContactInquiryJson;
};

/**
 * Describes the message guardianai.v1.contact.RetryInquiryNotificationsResponse.
 * Use `create(RetryInquiryNotificationsResponseSchema)` to create a new message.
 */
export const RetryInquiryNotificationsResponseSchema: GenMessage<RetryInquiryNotificationsResponse, {jsonType: RetryInquiryNotificationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_contact_contact, 10);

/**
 * @generated from enum guardianai.v1.contact.InquiryStatus
 */
export enum InquiryStatus {
  /**
   * @generated from enum value: INQUIRY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INQUIRY_STATUS_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: INQUIRY_STATUS_IN_REVIEW = 2;
   */
  IN_REVIEW = 2,

  /**
   * @generated from enum value: INQUIRY_STATUS_CONTACTED = 3;
   */
  CONTACTED = 3,

  /**
   * @generated from enum value: INQUIRY_STATUS_CLOSED = 4;
   */
  CLOSED = 4,

  /**
   * @generated from enum value: INQUIRY_STATUS_SPAM = 5;
   */
  SPAM = 5,
}

/**
 * @generated from enum guardianai.v1.contact.InquiryStatus
 */
export type InquiryStatusJson = "INQUIRY_STATUS_UNSPECIFIED" | "INQUIRY_STATUS_NEW" | "INQUIRY_STATUS_IN_REVIEW" | "INQUIRY_STATUS_CONTACTED" | "INQUIRY_STATUS_CLOSED" | "INQUIRY_STATUS_SPAM";

/**
 * Describes the enum guardianai.v1.contact.InquiryStatus.
 */
export const InquiryStatusSchema: GenEnum<InquiryStatus, InquiryStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_contact_contact, 0);

/**
 * @generated from enum guardianai.v1.contact.InquiryEmailDeliveryStatus
 */
export enum InquiryEmailDeliveryStatus {
  /**
   * @generated from enum value: INQUIRY_EMAIL_DELIVERY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INQUIRY_EMAIL_DELIVERY_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: INQUIRY_EMAIL_DELIVERY_STATUS_SENT = 2;
   */
  SENT = 2,

  /**
   * @generated from enum value: INQUIRY_EMAIL_DELIVERY_STATUS_FAILED = 3;
   */
  FAILED = 3,

  /**
   * @generated from enum value: INQUIRY_EMAIL_DELIVERY_STATUS_DISABLED = 4;
   */
  DISABLED = 4,
}

/**
 * @generated from enum guardianai.v1.contact.InquiryEmailDeliveryStatus
 */
export type InquiryEmailDeliveryStatusJson = "INQUIRY_EMAIL_DELIVERY_STATUS_UNSPECIFIED" | "INQUIRY_EMAIL_DELIVERY_STATUS_PENDING" | "INQUIRY_EMAIL_DELIVERY_STATUS_SENT" | "INQUIRY_EMAIL_DELIVERY_STATUS_FAILED" | "INQUIRY_EMAIL_DELIVERY_STATUS_DISABLED";

/**
 * Describes the enum guardianai.v1.contact.InquiryEmailDeliveryStatus.
 */
export const InquiryEmailDeliveryStatusSchema: GenEnum<InquiryEmailDeliveryStatus, InquiryEmailDeliveryStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_contact_contact, 1);

/**
 * Contact Service - Public website contact form
 *
 * @generated from service guardianai.v1.contact.ContactService
 */
export const ContactService: GenService<{
  /**
   * Public: durably record a contact inquiry before attempting notifications.
   *
   * @generated from rpc guardianai.v1.contact.ContactService.SubmitInquiry
   */
  submitInquiry: {
    methodKind: "unary";
    input: typeof SubmitInquiryRequestSchema;
    output: typeof SubmitInquiryResponseSchema;
  },
  /**
   * Admin-only: retrieve the durable inquiry inbox.
   *
   * @generated from rpc guardianai.v1.contact.ContactService.ListInquiries
   */
  listInquiries: {
    methodKind: "unary";
    input: typeof ListInquiriesRequestSchema;
    output: typeof ListInquiriesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.contact.ContactService.GetInquiry
   */
  getInquiry: {
    methodKind: "unary";
    input: typeof GetInquiryRequestSchema;
    output: typeof GetInquiryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.contact.ContactService.UpdateInquiryStatus
   */
  updateInquiryStatus: {
    methodKind: "unary";
    input: typeof UpdateInquiryStatusRequestSchema;
    output: typeof UpdateInquiryStatusResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.contact.ContactService.RetryInquiryNotifications
   */
  retryInquiryNotifications: {
    methodKind: "unary";
    input: typeof RetryInquiryNotificationsRequestSchema;
    output: typeof RetryInquiryNotificationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_contact_contact, 0);

